import React, { useState } from 'react';
import './tabs.css';

const eventData = {
  "Feb 6": [
    {
      time: "12:30 PM",
      title: "CodeX",
      location: "B2-Computer Labs",
      icon: "👨🏻‍💻",
      description: "For University Students ",
    },
    {
      time: "1:00 PM",
      title: "Buddhi क्षमता",
      location: "B1-First Floor",
      icon: "🧠",
      description: "For School Students",
    },
    {
      time: "1:00 PM",
      title: "Hack-a-thon",
      location: "B2-305",
      icon: "💻",
      description: "For School Students",
    },
    {
      time: "1:20 PM",
      title: "Rubik's Cube",
      location: "Kabaddi Ground, Near B1 Block",
      icon: "🎲",
      description: "For University Students",
    },
    {
      time: "2:00 PM",
      title: "Rubik's Cube",
      location: "Admin Ground",
      icon: "🎲",
      description: "For School Students",
    },
    {
      time: "2:00 PM",
      title: "Laser Light Show",
      location: "Mini Auditorium",
      icon: "🪩",
      description: "For University Students",
    },
    {
      time: "2:00 PM",
      title: "Robo दौड़",
      location: "BBC",
      icon: "🤖",
      description: "For School Students",
    },
    {
      time: "2:00 PM",
      title: "Robo फुटबॉल",
      location: "BBC",
      icon: "🤖",
      description: "For School Students",
    },
    {
      time: "2:05 PM",
      title: "Buddhi क्षमता",
      location: "Volleyball Court",
      icon: "🧠",
      description: "For University Students",
    },
    {
      time: "2:45 PM",
      title: "Recall-O-Tune",
      location: "B1-207,B2-007",
      icon: "🎶",
      description: "For School Students",
    },
    {
      time: "2:50 PM",
      title: "Reasoning Rumble",
      location: "Volleyball Court",
      icon: "🧩",
      description: "For University Students",
    },
    {
      time: "3:25 PM",
      title: "Reasoning Rumble",
      location: "Volleyball Court",
      icon: "🧩",
      description: "For School Students",
    },
    {
      time: "TBA",
      title: "Free Fire",
      location: "B2-305(Online Final Round)",
      icon: "🎮",
      description: "For School and University Students",
    },
  ],
  "Feb 7": [
    {
      time: "12:30 PM",
      title: "Robo दौड़",
      location: "BBC Ground",
      icon: "👨🏻‍💻",
      description: "For University Students",
    },
    {
      time: "12:30 PM",
      title: "Robo फुटबॉल",
      location: "BBC Ground",
      icon: "🧠",
      description: "For University Students",
    },
    {
      time: "2:00 PM",
      title: "Robo War",
      location: "B2-305",
      icon: "💻",
      description: "For University Students",
    },
    {
      time: "2:00 PM",
      title: "Path Finder: Robot",
      location: "B1-310",
      icon: "🎲",
      description: "For University Students",
    },
    {
      time: "3:30 PM",
      title: "Drone Race",
      location: "Cricket Ground",
      icon: "🎲",
      description: "For University Students",
    },
    {
      time: "3:30 PM",
      title: "Boat Race",
      location: "Open Arena",
      icon: "🪩",
      description: "For University Students",
    },
    {
      time: "TBA",
      title: "BGMI",
      location: "B2-305 (Final Round Only)",
      icon: "🤖",
      description: "For University Students",
    },
    {
      time: "4:30 PM",
      title: "Workshop on Configuring the Network Layers",
      location: "Mini Auditorium",
      icon: "🤖",
      description: "For University Students",
    },
  ],
  "Feb 8": [
    {
      time: "12:30 PM",
      title: "Find The Language",
      location: "B2 - All Labs",
      icon: "👨🏻‍💻",
      description: "For University Students",
    },
    {
      time: "12:30 PM",
      title: "Hack-a-Thon",
      location: "B2-305 , B1-007",
      icon: "🧠",
      description: "For University Students",
    },
    {
      time: "1:00 PM",
      title: "Structromania",
      location: "B5 Ground Floor",
      icon: "💻",
      description: "For University Students",
    },
    {
      time: "1:30 PM",
      title: "Recall-O-Tune",
      location: "B1-207 , B2-007",
      icon: "🎲",
      description: "For University Students",
    },
    {
      time: "2:15 PM",
      title: "Digi Art",
      location: "B2-006 , 004",
      icon: "🎲",
      description: "For University Students",
    },
    {
      time: "3:00 PM",
      title: "Generative AI / Power BI Workshop",
      location: "Mini Auditorium",
      icon: "🪩",
      description: "For University Students",
    },
    {
      time: "4:00 PM",
      title: "Bug Hunting",
      location: "B2-008",
      icon: "🤖",
      description: "For University Students",
    },
  ],
};

function App() {
  const [activeTab, setActiveTab] = useState('Feb 6');

  return (
    <div className="schedule-container">
      <div className="schedule-wrapper">
        <div className="schedule-header">
          <h1 className="schedule-title">EVENT SCHEDULE</h1>
          <p className="schedule-subtitle">Here is our event schedule</p>
          <div className="schedule-divider"></div>
        </div>

        <div className="tabs-container">
          {Object.keys(eventData).map((date) => (
            <button
              key={date}
              onClick={() => setActiveTab(date)}
              className={`tab-button ${activeTab === date ? 'active' : ''}`}
            >
              <span>📅</span>
              <span>{date}</span>
            </button>
          ))}
        </div>

        <div className="events-container">
          {eventData[activeTab].map((event, index) => (
            <div key={index} className="event-card">
              <div className="event-content">
                <div className="event-time">{event.time}</div>
                <div className="event-details">
                  <div className="event-header">
                    <div className="event-icon">{event.icon}</div>
                    <h3 className="event-title">{event.title}</h3>
                  </div>
                  <p className="event-description">{event.description}</p>
                  <div className="event-location">
                    <span className="location-icon">📍</span>
                    <span className='location-data'>Location: {event.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;